export * from './navbar.module';
export * from './navbar.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/navbars/index.js
// module id = ../../../../angular-bootstrap-md/navbars/index.js
// module chunks = 3